// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type HasUsersWithoutEntry } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useHasUsersWithoutEntry(): (
  id: string
) => Promise<HasUsersWithoutEntry> {
  const getAPI = useGetApi();
  return useCallback(
    async (id) => (await getAPI()).freeDays.hasUsersWithoutEntry({ id }),
    [getAPI]
  );
}
